import fetch from 'utils/fetch';
import qs from 'querystring';

class CaseManage {

    static addCase(caseInfo, callback) {
        const data = qs.stringify(caseInfo);
        return fetch({
            url: '/av1/caseManage/addCase',
            method: 'post',
            data
        }).then(callback)
    }

    static getCaseById(caseId, callback) {
        const data = qs.stringify({caseId});
        return fetch({
            url: '/av1/caseManage/getCaseById',
            method: 'post',
            data
        }).then(callback)
    }

    static delCase(caseId, esId, callback) {
        const data = qs.stringify({caseId, esId});
        return fetch({
            url: '/av1/caseManage/delCase',
            method: 'post',
            data
        }).then(callback)
    }

    static editCase(caseInfo, callback) {
        const data = qs.stringify(caseInfo);
        return fetch({
            url: '/av1/caseManage/editCase',
            method: 'post',
            data
        }).then(callback)
    }

    static reductionCase(caseId, callback) {
        const data = qs.stringify({caseId});
        return fetch({
            url: '/av1/caseManage/reductionCase',
            method: 'post',
            data
        }).then(callback)
    }

    static publishCase(caIds, callback) {
        const data = qs.stringify({caIds});
        return fetch({
            url: '/av1/caseManage/publishCases',
            method: 'post',
            data
        }).then(callback)
    }

    static forbidCases(caIds, caState, callback) {
        const data = qs.stringify({caIds, caState});
        return fetch({
            url: '/av1/caseManage/forbidCases',
            method: 'post',
            data
        }).then(callback)
    }

    static getCaseList(pageNum, pageSize, status, startTime, endTime, searchValue, sortMap, callback) {

        const data = qs.stringify({
            pageNum,
            pageSize,
            status,
            startTime,
            endTime,
            searchValue,
            sortMap
        });
        return fetch({
            url: '/av1/caseManage/caseList',
            method: 'post',
            data
        }).then(callback);
    }

    static getMedias(callback) {
        return fetch({
            url: '/av1/categoryManage/getMediaList',
            method: 'get'
        }).then(callback);
    }

    static getUserRole(callback) {
        return fetch({
            url: '/av1/categoryManage/getUserRole',
            method: 'get'
        }).then(callback);
    }


    static getLanguage(callback) {
        return fetch({
            url: '/av1/categoryManage/getLanguage',
            method: 'get'
        }).then(callback);
    }

    static upCaseIndex(caUid, caIndex) {
        const data = qs.stringify({
            caUid,
            caIndex
        });
        return fetch({
            url: '/av1/caseManage/upCaseIndex',
            method: 'post',
            data
        });
    }
    static caUserInfo(caUser) {
        const data = qs.stringify({
            caUser
        });
        return fetch({
            url: '/av1/caseManage/caUserInfo',
            method: 'post',
            data
        });
    }
}

module.exports = CaseManage;



// WEBPACK FOOTER //
// ./src/api/CaseManage.js